function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { KEY_ENTER, KEY_SPACE, MIN_HD_RESOLUTION } from "@config/constants";
var SettingsButton = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(SettingsButton, Component);
    var _super = _create_super(SettingsButton);
    function SettingsButton(props) {
        _class_call_check(this, SettingsButton);
        var _this;
        _this = _super.call(this, props);
        _this.settingsButton = null;
        _this.openFromKeyboard = _this.openFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(SettingsButton, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var videoPlayer = this.props.videoPlayer;
                return nextProps.videoPlayer.video.levels !== videoPlayer.video.levels || nextProps.videoPlayer.video.currentLevel !== videoPlayer.video.currentLevel;
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(param) {
                var playerOptionsAdditionalProps = param.playerOptionsAdditionalProps;
                if (this.props.playerOptionsAdditionalProps.isOpenSettingsList !== playerOptionsAdditionalProps.isOpenSettingsList && this.props.playerOptionsAdditionalProps.shouldFocusSettingsButton) {
                    this.settingsButton.focus();
                }
            }
        },
        {
            /**
     * Opens the settings list on enter or space keydown
     * @param event
     */ key: "openFromKeyboard",
            value: function openFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.props.actions.toggleSettingsList(true);
                    event.stopPropagation();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, actions = _this_props.actions, i18n = _this_props.i18n;
                var currentLevel = videoPlayer.video.currentLevel || 0;
                var currentLevelHeight = currentLevel && videoPlayer.video.levels && videoPlayer.video.levels[currentLevel] ? videoPlayer.video.levels[currentLevel].height : null;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "settings-button player-button",
                    onClick: function() {
                        return actions.toggleSettingsList(false);
                    },
                    onKeyDown: this.openFromKeyboard,
                    ref: function(node) {
                        return _this.settingsButton = node;
                    },
                    "data-tip": i18n.player.settings,
                    "data-for": "player-tooltip",
                    tabIndex: "0",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-settings pointer"
                        }),
                        currentLevel && currentLevelHeight > MIN_HD_RESOLUTION ? /*#__PURE__*/ _jsx("span", {
                            className: "hd-label",
                            children: "HD"
                        }) : null
                    ]
                });
            }
        }
    ]);
    return SettingsButton;
}(Component);
export default SettingsButton;
